import { handleActions } from 'redux-actions';
// import { types } from '../constants';
import { types, inputFieldNames } from '../constants';

const INITIAL_STATE = {
  newBranch: {
    showCreateBranchDialog: false,
    showEditBranchDialog: false,
    item: {},
    isSaving: false,
    errorMessage: ''
  },
  branch: {
    item: null,
    isLoading: false,
    errorMessage: ''
  },
  deleteOrDeactivatingBranch: {
    open: false,
    isSaving: false,
    branchId: 0,
    errorMessage: '',
    status: 0,
    item: {}
  }
};

const openCreateBranchDialog = (state, { open }) => {
  return {
    ...state,
    newBranch: {
      ...state.newBranch,
      showCreateBranchDialog: open,
      item: {}
    }
  };
};

function showDeleteOrDeactiveBranchDialog(state, { open, branchId, status }) {
  return {
    ...state,
    deleteOrDeactivatingBranch: {
      ...state.deleteOrDeactivatingBranch,
      open,
      errorMessage: '',
      branchId,
      isSaving: false,
      status
    }
  };
}

const openEditBranchDialog = (state, { open }) => {
  return {
    ...state,
    newBranch: {
      ...state.newBranch,
      showEditBranchDialog: open,
      item: {}
    }
  };
};

const inputChangeCreateEditBranchForm = (state, { value, inputFieldName }) => {
  const branch = { ...state.newBranch.item };
  switch (inputFieldName) {
    case inputFieldNames.NAME:
      branch.name = value;
      break;
    case inputFieldNames.CONTACT_PERSON:
      branch.contactPerson = value;
      break;
    case inputFieldNames.EMAIL:
      branch.email = value;
      break;
    case inputFieldNames.PHONE:
      branch.phone = value;
      break;
    case inputFieldNames.FAX:
      branch.fax = value;
      break;
    case inputFieldNames.ADDRESS:
      branch.address = value;
      break;
    case inputFieldNames.NOTES:
      branch.notes = value;
      break;
    case inputFieldNames.COMPANY:
      branch.companyId = parseInt(value);
      break;
    default:
      break;
  }

  return {
    ...state,
    newBranch: {
      ...state.newBranch,
      item: branch
    }
  };
};

const startSubmitBranch = (state) => {
  return {
    ...state,
    newBranch: {
      ...state.newBranch,
      isSaving: true
    }
  };
};

const submitBranchesuccess = (state, { submittedBranch }) => {
  return {
    ...state,
    branch: {
      ...state.Branch,
      item: submittedBranch
    }
  };
};

const submitBranchFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newBranch: {
      ...state.newBranch,
      errorMessage
    }
  };
};

const submitBranchFinished = (state) => {
  return {
    ...state,
    newBranch: {
      ...state.newBranch,
      isSaving: false
    }
  };
};

const editBranch = (state, { branch }) => {
  return {
    ...state,
    newBranch: {
      ...state.newBranch,
      item: branch
    }
  };
};

const startFetchBranchDetailsForLoggedInUser = (state) => {
  return {
    ...state,
    branch: {
      ...state.branch,
      isLoading: true
    }
  };
};

const fetchBranchDetailsForLoggedInUserSuccess = (state, { branch }) => {
  return {
    ...state,
    branch: {
      ...state.branch,
      item: branch
    }
  };
};

const fetchBranchDetailsForLoggedInUserFailure = (state, { errorMessage }) => {
  return {
    ...state,
    branch: {
      ...state.branch,
      errorMessage
    }
  };
};

const fetchBranchDetailsForLoggedInUserFinished = (state) => {
  return {
    ...state,
    branch: {
      ...state.branch,
      isLoading: false
    }
  };
};

const startFetchBranchDetailsByBranchId = (state) => {
  return {
    ...state,
    branch: {
      ...state.branch,
      isLoading: true
    }
  };
};

const fetchBranchDetailsByBranchIdSuccess = (state, { branch }) => {
  return {
    ...state,
    branch: {
      ...state.branch,
      item: branch
    }
  };
};

const fetchBranchDetailsByBranchIdFailure = (state, { errorMessage }) => {
  return {
    ...state,
    branch: {
      ...state.branch,
      errorMessage
    }
  };
};

const fetchBranchDetailsByBranchIdFinished = (state) => {
  return {
    ...state,
    branch: {
      ...state.branch,
      isLoading: false
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.OPEN_CREATE_BRANCH_DIALOG]: openCreateBranchDialog,
    [types.OPEN_EDIT_BRANCH_DIALOG]: openEditBranchDialog,

    [types.INPUT_CHANGE_CREATE_BRANCH_FORM]: inputChangeCreateEditBranchForm,

    [types.START_SUBMIT_BRANCH]: startSubmitBranch,
    [types.SUBMIT_BRANCH_SUCCESS]: submitBranchesuccess,
    [types.SUBMIT_BRANCH_FAILURE]: submitBranchFailure,
    [types.SUBMIT_BRANCH_FINISHED]: submitBranchFinished,

    [types.EDIT_BRANCH]: editBranch,

    [types.DEACTIVATE_OR_DELETE_BRANCH_DIALOG]: showDeleteOrDeactiveBranchDialog,

    [types.START_FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER]: startFetchBranchDetailsForLoggedInUser,
    [types.FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_SUCCESS]: fetchBranchDetailsForLoggedInUserSuccess,
    [types.FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_FAILURE]: fetchBranchDetailsForLoggedInUserFailure,
    [types.FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_FINISHED]: fetchBranchDetailsForLoggedInUserFinished,

    [types.START_FETCH_BRANCH_DETAILS_BY_BRANCH_ID]: startFetchBranchDetailsByBranchId,
    [types.FETCH_BRANCH_DETAILS_BY_BRANCH_ID_SUCCESS]: fetchBranchDetailsByBranchIdSuccess,
    [types.FETCH_BRANCH_DETAILS_BY_BRANCH_ID_FAILURE]: fetchBranchDetailsByBranchIdFailure,
    [types.FETCH_BRANCH_DETAILS_BY_BRANCH_ID_FINISHED]: fetchBranchDetailsByBranchIdFinished
  },
  INITIAL_STATE
);
